import React, { useContext, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

import AppContext from '../../../context';
import { resetPortfolio } from '../../../../api';
import './clear_pf.component.css';

const ClearPf = (props) => {
  // Context
  const context = useContext(AppContext);
  const { pf, show, setShow, setContext, instrument } = props;
  const portfolio_id = pf.id;

  const [isClearing, setIsClearing] = useState(false);

  const onClearPortfolio = async () => {
    setIsClearing(true);
    try {
      const payload = {};
      if (instrument) {
        if (instrument === 'mfs') {
          payload.reset_mf = true;
        }
        if (instrument === 'stocks') {
        }
        const response = await resetPortfolio(portfolio_id, payload);
        location.reload();
        return;
      }

      payload.clear_all = true;
      const response = await resetPortfolio(portfolio_id, payload);
      let pfs = _.cloneDeep(context.portfolios);
      const pfIdx = context.portfolios.findIndex(
        (_pf) => _pf.id == portfolio_id,
      );
      pfs[pfIdx] = {
        id: pfs[pfIdx].id,
        name: pfs[pfIdx].name,
        is_empty: true,
        is_mf_eligible_to_sync: true,
      };
      setContext({
        portfolios: pfs,
        resetPf: { resetId: portfolio_id, switchId: pfs[1].id },
      });
      setIsClearing(false);
      setShow(false);
    } catch (e) {
      setIsClearing(false);
      console.log(e);
    }
  };

  return (
    <>
      <Modal
        show={show}
        centered
        className={`clear_pf__modal ${props.className}`}
        onHide={() => setShow(false)}
      >
        <Modal.Body>
          <h4>
            Clear{' '}
            {!instrument ? pf.name : instrument === 'mfs' ? 'MFs' : 'stocks'}
          </h4>
          <div>
            <p>
              Are you sure you wish to clear{' '}
              {instrument && (instrument === 'mfs' ? 'MFs' : 'stocks')} holdings
              {instrument && ` of ${pf.name}`}?
            </p>
            {(!instrument || instrument === 'mfs') && pf.next_sync_time && (
              <p>
                Please note you will be able to re-sync mutual fund holdings
                next on {pf.next_sync_time}
              </p>
            )}
          </div>
          <div className="btns__cont">
            <button
              type="button"
              className="cancel_btn"
              onClick={() => setShow(false)}
            >
              No, Cancel
            </button>
            <button
              type="button"
              className="confirm_btn"
              onClick={onClearPortfolio}
              disabled={isClearing}
            >
              {isClearing ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    color="#676767"
                    className="mr-2"
                  />
                  <span>
                    Clearing{' '}
                    {!instrument
                      ? 'Portfolio'
                      : instrument === 'mfs'
                      ? 'MFs'
                      : 'stocks'}
                  </span>
                </>
              ) : (
                <span>Yes, Clear</span>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClearPf;
